import { Controller } from "@hotwired/stimulus"
import Tagify from "@yaireo/tagify"

export default class extends Controller {
  static targets = ["input", "hiddenField"]

  connect() {
    console.log("Tagify controller connected")
    this.tagify = new Tagify(this.inputTarget, {
      whitelist: [],
      maxTags: 10,
      dropdown: {
        // position: "all",
        maxItems: 20,           // <- mixumum allowed rendered suggestions
        classname: "tags-look", // <- custom classname for this dropdown, so it could be targeted
        enabled: 0,             // <- show suggestions on focus
        closeOnSelect: false    // <- do not hide the suggestions dropdown once an item has been selected
      }
    });
    this.tagify.addTags(this.hiddenFieldTarget.value);

    // Updated to use the admin endpoint
    fetch("/admin/guides/get_guides_tags", {
      headers: {
        "Accept": "application/json"
      }
    })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error(`Failed to get tags: ${response.status}`);
          }
        })
        .then(tags => {
          // Update the whitelist with the tags from the server
          this.tagify.settings.whitelist = this.tagify.settings.whitelist.concat(tags);
        })
        .catch(error => {
          console.error(error);
        });

    this.tagify.on('add', () => this.updateHiddenField());
    this.tagify.on('remove', () => this.updateHiddenField());
  }

  updateHiddenField() {
    console.log("updateHiddenField")
    if (this.hiddenFieldTarget) {
      this.hiddenFieldTarget.value = this.tagify.value.map(tag => tag.value).join(',');
    }
  }

  disconnect() {
    this.tagify.destroy()
  }
}